export default __webpack_public_path__ + "static/media/ev-accommodation.e68a229d.svg";